<template>
  <div id="renewModal" class="modal fade" role="dialog" data-backdrop="static">
    <div class="modal-dialog upgrade-account-modal">
      <div class="modal-content first-modal-content">
        <div class="modal-header upgradeModal-bgcolor">
          <button type="button" class="close" @click="closePopup" data-target="#renewModal">
            &times;
          </button>
          <div class="modal-title">
            <div class="upgrade-service-para">
              <span>Renew Account Add-on(s)</span>
            </div>
          </div>
        </div>
        <div class="modal-body confirm-body">
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-lg-7 col-md-7 col-sm-7 text-left">
                  <div class="upgrade-team">Team Members</div>
                  <div class="current-limit">(Current members: {{ currentUtilization }})</div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-5">
                  <div class="additional-price" v-if="team_member">
                    Price:
                    <span v-if="team_member.label !== '5 members'">Additional </span>
                    {{ team_member.desc }}
                  </div>
                  <multiselect
                    class="multiselect-single-dropdown max-height-150"
                    :class="!team_member ? 'un-selected' : ''"
                    :show-labels="false"
                    :allow-empty="false"
                    :searchable="false"
                    :options="team_members"
                    v-model="team_member"
                    label="label"
                  >
                    <template slot="singleLabel" slot-scope="props">
                      <span class="option_name">{{ props.option.label }}</span>
                    </template>
                    <template slot="option" slot-scope="props">
                      <span class="option_name">{{ props.option.label }}</span>
                    </template>
                  </multiselect>
                </div>
                <div class="col-md-12 col-sm-12 col-xs-12 text-center adjust-service">
                  * Some options may not be available, adjust the service’s current amounts to
                  enable them
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer cancelModal-bgcolor">
          <div class="col-lg-6 col-sm-6 col-md-6 p-0 text-left please-cancel-btn">
            <button class="btn emergo-white-button wd-250" @click="closePopup()">Cancel</button>
          </div>
          <div class="col-lg-6 col-sm-6 col-md-6 p-0 text-right">
            <button class="btn emergo-blue-button wd-250" @click="renewAccount(false)">
              Renew Add-ons
            </button>
          </div>
        </div>
        <loader :loadingStatus="loaderStatus"></loader>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import $ from 'jquery';
import cloneDeep from 'lodash/cloneDeep';
import { getAddonDetails, getPaymentModes } from '../../../apis/psm';
import { getSubscribedPlans } from '../../../apis/plans';
import { teamMembers } from '../../../utils/constants';
import Loader from '../../UIComponents/Loader.vue';

export default {
  components: {
    Loader
  },
  data() {
    return {
      errorMessage: '',
      newExpirationDate: '',
      loaderStatus: false,
      addonDetails: [],
      team_member: '',
      teamLimit: 0,
      team_members: cloneDeep(teamMembers),
      subscribedPlans: [],
      currentUtilization: 0,
      teamMember: '',
      paymentOptionsList: [],
      isGreaterthan25: false
    };
  },
  filters: {
    dateFormat(date) {
      return moment(date).format('MM/DD/YYYY');
    }
  },
  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    todayDate() {
      return moment().utc().format('YYYY-MM-DD HH:mm:ss');
    },
    closePopup() {
      $('#renewModal').modal('hide');
    },
    displayTeam() {
      const teamIndex = this.addonDetails.findIndex((addon) => addon.units === 'USERS');
      // [this.team_member] = this.team_members;
      if (teamIndex >= 0) {
        this.teamMember = this.addonDetails[teamIndex];
        if (this.isREP) {
          this.teamLimit = this.teamMember.total_limit - 1;
        } else {
          this.teamLimit = this.teamMember.total_limit;
        }
      }
      this.currentUtilization = this.isREP
        ? this.teamMember.current_utilization - 1
        : this.teamMember.current_utilization;
      this.team_members.forEach((member, index) => {
        if (member.value + 5 < this.currentUtilization) this.team_members[index].$isDisabled = true;
      });
    },
    async getAddonDetails() {
      this.addonDetails = await getAddonDetails(
        JSON.parse(localStorage.getItem('userData')).account_id
      );
      this.displayTeam();
    },
    async getSubscribedPlansList() {
      this.subscribedPlans = await getSubscribedPlans(
        JSON.parse(localStorage.getItem('userData')).account_id
      );
      await this.getAddonDetails();
    },
    async renewAccount() {
      this.$emit('payForUpgradeService', this.teamMember, this.team_member, true);
    }
  },
  async mounted() {
    const accountTypeId = JSON.parse(localStorage.getItem('userData')).account_type_id;
    this.isREP = accountTypeId === 2 || accountTypeId === 4;
    await this.getSubscribedPlansList();
    this.paymentOptionsList = await getPaymentModes();
  }
};
</script>

<style lang="scss" scoped>
.plr-30 {
  padding: 0 30px;
}
img {
  &.success_logo {
    &.card-img-top {
      width: 60px;
      height: 60px;
      background-color: $light-green;
      border-radius: 50%;
      padding: 10px;
      margin-top: 5px;
    }
  }
}
h5 {
  color: $deep-gray;
  font-weight: $font-weight-normal;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
.modal-header {
  .close {
    background: none;
    opacity: 1;
    height: 17px;
    color: $deep-gray !important;
    width: 17px;
    border-radius: $radius20;
    @include fontItems($font-32, 17px, $font-weight-small);
    outline: none;
  }
  &.upgradeModal-bgcolor {
    background-color: $deep-white;
    border: 0px;
    border-top-left-radius: $radius10;
    border-top-right-radius: $radius10;
    padding: 24px;
  }
}
.confirm-body {
  padding: 0 24px;
  font-family: Roboto;
  font-style: normal;
  font-weight: $font-weight-normal;
  text-align: center;
  color: $dark-black-alpha;
}
.modal-footer {
  &.cancelModal-bgcolor {
    background-color: $deep-white;
    border: 0px;
    border-bottom-left-radius: $radius10;
    border-bottom-right-radius: $radius10;
    padding: 34px 24px 24px;
  }
}
.modal-content {
  &.first-modal-content {
    border-radius: 12px;
  }
}
.modal-title {
  &.service-modal-title {
    text-align: center;
  }
}
div#renewModal {
  background-color: rgba(0, 0, 0, 0.5);
}
.upgrade-service-para {
  @include fontItems($font-24, 28px, $font-weight-medium);
  text-align: left;
  color: $primary;
}
.additional-price {
  text-align: center;
  color: $light-green;
  font-size: $font-14;
  line-height: 16px;
  font-weight: $font-weight-medium;
  margin-bottom: 10px;
}
.adjust-service,
.credit-charges {
  font-size: 13px;
  line-height: 15px;
  color: $dark-black-alpha;
  padding-top: 16px;
}
.credit-charges {
  padding-top: 8px;
  padding-bottom: 10px;
}
.existing-payment {
  font-weight: $font-weight-medium;
  font-size: $font-14;
  line-height: 16px;
  color: $dark-black-alpha;
}
.wd-250 {
  width: 250px;
}
.contact-us {
  font-weight: $font-weight-medium;
  font-size: $font-16;
  line-height: 20px;
  color: $messenger-blue;
  text-decoration-line: underline;
  padding-top: 24px;
  cursor: pointer;
}
.upgrade-team {
  font-size: $font-18;
  font-weight: $font-weight-400;
  line-height: 21px;
  color: $dark-black-alpha;
}
.current-limit {
  font-size: $font-14;
  font-weight: $font-weight-400;
  line-height: 16px;
  color: $dark-black-alpha;
  padding-top: 8px;
}
.multiselect-single-dropdown {
  width: 180px;
}
.multiselect-single-dropdown {
  ::v-deep .multiselect__single {
    width: 100%;
  }
}
.multiselect-single-dropdown {
  ::v-deep .multiselect__content-wrapper {
    max-height: 150px !important;
  }
}
/* module - features */
@media only screen and (max-width: 767px) {
  .please-cancel-btn {
    margin-bottom: 14px;
  }
  .modal-footer .btn {
    margin-bottom: 10px;
  }
  .upgrade-service-para {
    font-size: $font-20;
  }
  .additional-price {
    margin-top: 10px;
  }
  .wd-250 {
    width: 100%;
  }
  .text-left {
    text-align: center;
  }
}
@media only screen and (min-width: 768px) {
  .upgrade-account-modal {
    width: 580px;
  }
}
</style>
